import React, { useEffect, Fragment, createElement } from 'react';
import { LandingPage } from './components/LandingPage';
// === CRITICAL RESOURCES — injected as single fragment to avoid reflows ===
const fragment = document.createDocumentFragment();
// Preconnect to image CDN
const pc = document.createElement('link');
pc.rel = 'preconnect';
pc.href = 'https://cdn.magicpatterns.com';
fragment.appendChild(pc);
// Preload hero image (LCP element)
const preload = document.createElement('link');
preload.rel = 'preload';
preload.as = 'image';
preload.setAttribute('imagesizes', '(max-width: 768px) 100vw, 768px');
preload.href = 'https://cdn.magicpatterns.com/uploads/87dYyEWwxvxDSawQQfbd23/WhatsApp_Image_2026-03-23_at_23.51.54.jpg';
fragment.appendChild(preload);
// Non-blocking Google Fonts
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Oswald:wght@400;700;800&display=swap';
fontLink.media = 'print';
fontLink.onload = function () {
  fontLink.media = 'all';
};
fragment.appendChild(fontLink);
// Single DOM write
document.head.appendChild(fragment);
// === META PIXEL — deferred until after page is interactive ===
let pixelLoaded = false;
function loadPixel() {
  if (pixelLoaded) return;
  pixelLoaded = true;
  const fbq: any = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [] as any[];
  (window as any).fbq = fbq;
  (window as any)._fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  fbq('init', '1272637858178142');
  fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    // Defer pixel loading until browser is idle or after 3s
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 3000);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}